import { Component, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA, MatDialogTitle, MatDialogContent, MatDialogActions, MatDialogClose } from '@angular/material/dialog';
import { finalize } from 'rxjs/operators';
import { AuditLogsService } from '@app/core/stingray-api/services';
import { AuditLogEntry, AuditLogEntries } from '@app/core/stingray-api/models';
import { Shell } from '@app/shell/shell.service';
import { MatButton } from '@angular/material/button';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { TitleCasePipe, DatePipe } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'unite-audit-log-detail',
    templateUrl: './audit-log-detail.component.html',
    styleUrls: ['./audit-log-detail.component.scss'],
    imports: [MatDialogTitle, TranslateModule, MatDialogContent, MatProgressSpinner, MatDialogActions, MatButton, MatDialogClose, TitleCasePipe, DatePipe]
})
export class AuditLogDetailComponent {

  title: string;
  auditLogEntries: AuditLogEntry[] = null;
  isLoadingAuditLogEntries: boolean;

  isSession: boolean;

  constructor(
    private matDialog: MatDialog,
    private auditLogsService: AuditLogsService,
    private matDialogRef: MatDialogRef<AuditLogDetailComponent>,
    @Inject(MAT_DIALOG_DATA) private auditLogDetailData: AuditLogDetailData) {
    if (auditLogDetailData.sessionId === undefined || auditLogDetailData.sessionId === null) {
      this.title = auditLogDetailData.entityShortName;
      this.isSession = false;
      this.loadEntityAuditLogEntries();
    } else {
      this.title = 'Session - ' + auditLogDetailData.sessionId;
      this.isSession = true;
      this.loadSessionAuditLogEntries();
    }
  }


  getRowSpan(selectedAuditLogEntry: AuditLogEntry): number {
    return this.auditLogEntries.filter(auditLogEntry => auditLogEntry.sessionId === selectedAuditLogEntry.sessionId).length;
  }

  openAuditSession(auditLogEntry: AuditLogEntry) {
    Shell.auditDialog(
      this.matDialog,
      AuditLogDetailComponent,
      { sessionId: auditLogEntry.sessionId }
    );
  }

  openAuditEntity(auditLogEntry: AuditLogEntry) {
    Shell.auditDialog(
      this.matDialog,
      AuditLogDetailComponent,
      {
        entityShortName: auditLogEntry.entityShortName,
        entityId: auditLogEntry.entityId
      }
    );
  }

  private loadSessionAuditLogEntries() {
    this.isLoadingAuditLogEntries = true;
    this.auditLogsService.getAuditLogSessionById({
      sessionId: this.auditLogDetailData.sessionId,
      sort: "timestamp",
      order: "Desc",
    }).pipe(finalize(() => this.isLoadingAuditLogEntries = false)).subscribe((auditLogEntries: AuditLogEntries) => {
      this.auditLogEntries = auditLogEntries.items;
    });
  }

  private loadEntityAuditLogEntries() {
    this.isLoadingAuditLogEntries = true;
    this.auditLogsService.getAuditLogEntityById({
      entityId: this.auditLogDetailData.entityId,
      entityShortName: this.auditLogDetailData.entityShortName,
      sort: "timestamp",
      order: "Desc",
    }).pipe(finalize(() => this.isLoadingAuditLogEntries = false)).subscribe((auditLogEntries: AuditLogEntries) => {
      this.auditLogEntries = auditLogEntries.items;
    });
  }
}

export interface AuditLogDetailData {
  sessionId?: string;
  entityId?: string;
  entityShortName?: string;
}
